import { Title, Text, Group, Badge, Box, ThemeIcon, Stack, Paper, Flex } from "@mantine/core";
import { IconSparkles, IconCircleCheck, IconWorld, IconFile, IconBolt } from "@tabler/icons-react";

export default function GTAISection() {
  return (
    <Box
      style={{ background: "linear-gradient(to top, rgba(235, 248, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%)" }}
      py={60}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={60}
        px="xl"
        maw={1200}
        mx="auto"
        w="100%"
        align={{ base: "center", md: "flex-start" }}
      >
        {/* Left Content */}
        <Stack gap="lg" flex={1}>
          <Group>
            <Badge
              variant="light"
              color="primary"
              size="lg"
              radius="xl"
              leftSection={<IconSparkles size={14} />}
              style={{
                background: "var(--mantine-color-primary-1 10%)",
                border: "1px solid var(--mantine-color-primary-1 30%)",
              }}
            >
              AI-POWERED
            </Badge>
          </Group>
          <Title order={2} c="slate.8">
            GT Setu AI – Company Profile Generator
          </Title>
          <Text c="slate.6" size="lg">
            Let our AI generate comprehensive company profiles automatically. Simply provide your company URL and upload
            a brochure – GT Setu AI does the rest.
          </Text>
          <Stack gap="md" mt="md">
            <Group align="flex-start" wrap="nowrap">
              <IconCircleCheck color="var(--mantine-color-primary-6)" size={20} style={{ flexShrink: 0 }} />
              <Text c="slate.6">
                <Text span fw={600} c="slate.7">
                  AI-powered structured profiles
                </Text>
                : Extract key data from your website and documents
              </Text>
            </Group>
            <Group align="flex-start" wrap="nowrap">
              <IconCircleCheck color="var(--mantine-color-primary-6)" size={20} style={{ flexShrink: 0 }} />
              <Text c="slate.6">
                <Text span fw={600} c="slate.7">
                  Faster onboarding
                </Text>
                : Complete your profile in minutes, not hours
              </Text>
            </Group>
            <Group align="flex-start" wrap="nowrap">
              <IconCircleCheck color="var(--mantine-color-primary-6)" size={20} style={{ flexShrink: 0 }} />
              <Text c="slate.6">
                <Text span fw={600} c="slate.7">
                  Comprehensive coverage
                </Text>
                : Capabilities, certifications, markets, and more
              </Text>
            </Group>
          </Stack>
        </Stack>

        {/* Right Card */}
        <Box pos="relative" mx="auto" w="100%" maw={650} flex={1}>
          <Paper radius="lg" p="xl" withBorder shadow="md" style={{ border: "1px solid #2563EB33" }}>
            {/* Floating Badge */}
            <Badge
              color="linear-gradient(to right, var(--mantine-color-primary-6), var(--mantine-color-primary-6) 80%)"
              variant="filled"
              size="lg"
              h="xl"
              radius={40}
              leftSection={
                <ThemeIcon variant="transparent" size="xs">
                  <IconBolt size={16} color="white" />
                </ThemeIcon>
              }
              pos="absolute"
              top={-12}
              right={-10}
              style={{
                zIndex: 10,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              5 min setup
            </Badge>

            <Stack gap="md">
              {/* Card Header */}
              <Group gap="sm">
                <ThemeIcon
                  size={40}
                  radius={40}
                  color="linear-gradient(to right, var(--mantine-color-primary-6), var(--mantine-color-primary-6) 70%)"
                >
                  <IconSparkles size={20} />
                </ThemeIcon>
                <div>
                  <Text fw={700} size="md">
                    GT Setu AI Assistant
                  </Text>
                  <Text size="xs" c="slate.6">
                    Profile Generator
                  </Text>
                </div>
              </Group>

              {/* Form Fields - Vertical Stack Layout */}
              <Paper p="md" bg="gray.0" radius="lg">
                <Group gap="xs" mb="xs">
                  <IconWorld size={16} color="var(--mantine-color-primary-6)" />
                  <Text size="sm" fw={500} c="slate.7">
                    Company URL
                  </Text>
                </Group>
                <Text size="sm" c="slate.6" pl={24}>
                  www.yourcompany.com
                </Text>
              </Paper>

              <Paper p="md" bg="gray.0" radius="lg">
                <Group gap="xs" mb="xs">
                  <IconFile size={16} color="var(--mantine-color-primary-6)" />
                  <Text size="sm" fw={500} c="slate.7">
                    Brochure Upload
                  </Text>
                </Group>
                <Text size="sm" c="slate.6" pl={24}>
                  company-profile.pdf
                </Text>
              </Paper>

              {/* Status */}
              <Paper
                p="md"
                radius="lg"
                bg="primary.0"
                withBorder
                style={{ borderColor: "var(--mantine-color-primary-2)" }}
              >
                <Group gap="xs">
                  <Box w={8} h={8} style={{ borderRadius: "50%", backgroundColor: "var(--mantine-color-primary-6)" }} />
                  <Text size="sm" c="primary.7" fw={500}>
                    Generating profile...
                  </Text>
                </Group>
              </Paper>
            </Stack>
          </Paper>
        </Box>
      </Flex>
    </Box>
  );
}
